<template>
  <div class="row align-center">
    <div class="small-12 medium-9 large-9 columns content">
      <noticiaDep v-for="(item,index) in getCurrentPageNoticias"
               :titulo="item.titulo"
               :imagem="item.imagem"
               :corpo="item.corpo"
               :url="item.url"
               :colorClass="$store.state.departamento.Faculdade.name"
               :key="index"/>
      <pagination
          :color="colorpagination"
          @change-page="fetchPage"
          @load-more="getNextItems"
          :total-elements="totalElements"
          :currentPage="currentPage"
          :list-length="getCurrentPageNoticiasSize"
          :limit="limit" />
    </div>
  </div>
</template>

<script>
import noticiaDep from '../components/noticia.vue';
import pagination from '../components/pagination.vue'

export default {
  name:"noticiasDepartamento",
  components: {
    noticiaDep,
    pagination
  },
  inject:["secundaryColors"],
  data(){
    return {
      listItems: [ ],
      currentPage: 1,
      limit:10,
      start:0,
      end:0,
      totalElements: 0,
      colorpagination: ""
    }
  },
  created(){
    window.addEventListener("resize", this.myEventHandler);
    this.fetchDestaques();
  },
  updated() {
    this.colorpagination = this.secundaryColors[this.$store.state.color];
  },
  unmounted() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  computed:{
    getCurrentPageNoticias(){
      return this.listItems.slice(this.start,this.end);
    },
    getCurrentPageNoticiasSize(){
      return this.listItems.slice(this.start,this.end).length;
    }
  },
  methods:{
    myEventHandler() {
      if(window.outerWidth > 767){
        this.end = this.currentPage*this.limit;
        this.start = this.end - this.limit;
      }else{
        this.start = 0;
        this.end = this.currentPage * this.limit;
      }
    },
    fetchPage(page){
      this.end = page*this.limit;
      this.start = this.end - this.limit;
      this.currentPage = page;
      window.scrollTo(0, 0);
    },
    getNextItems(){
      this.currentPage = this.currentPage + 1;
      this.start = 0;
      this.end = this.currentPage * this.limit;
    },
    fetchDestaques(){
      let request = `${process.env.VUE_APP_AXIOS}/departamento/${this.$route.params.id}/destaques?idioma=${this.$store.state.language}`;
      fetch(request)
          .then(response => response.json())
          .then(data => {
            this.totalElements = data.length;
            this.end = this.limit;
            this.listItems = data.map(el => {
              return {
                id: el.ID,
                titulo: el.Nome,
                corpo: el.Texto,
                imagem: el.Imagem,
                url: el.Url
              }
            });
          })
          .catch(error => console.log(error));
    }
  }
}
</script>

<style scoped>


.content {
      padding-right: 80px;
      padding-left: 80px;
}


@media (max-width: 1440px) {

  .content {
    padding-right: 40px;
    padding-left: 40px;
  }
}


@media (max-width: 1300px) {

  .content {
    padding-right: 0px;
    padding-left: 0px;
  }

}























</style>